import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css';

export default {
    data() {
        return {
            isLeftArrowHidden: true,
            isRightArrowHidden: false
        };
    },
    methods: {
        scrollLeft() {
            this.$refs.scrollRef.$el.scrollTo({
                left: this.$refs.scrollRef.$el.scrollLeft - 500,
                behavior: 'smooth'
            });
        },
        scrollRight() {
            this.$refs.scrollRef.$el.scrollTo({
                left: this.$refs.scrollRef.$el.scrollLeft + 500,
                behavior: 'smooth'
            });
        },
        handleScroll() {
            const totalWidth = this.$refs.scrollRef.$el.scrollWidth - this.$refs.scrollRef.$el.clientWidth;
            const scrolledWidth = this.$refs.scrollRef.$el.scrollLeft;
            const scrollPercentage = (scrolledWidth / totalWidth) * 500;

            this.isLeftArrowHidden = scrollPercentage === 0;
            this.isRightArrowHidden = scrollPercentage === 500;
        }
    }
};
